import { useLocation } from "react-router-dom";

export const AppHeader = () => {
  const location = useLocation();

  // Don't show on splash, onboarding, auth pages, or pages with bottom nav
  const hiddenPaths = ["/", "/onboarding", "/auth", "/home", "/saved-gifts", "/settings", "/results", "/notifications"];
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <header 
      className="relative w-full border-b border-border/60 bg-card/80 backdrop-blur-xl z-50 shadow-[0_1px_3px_hsl(var(--foreground)/0.06)]"
      style={{ paddingTop: 'var(--safe-area-top, 0)' }}
    >
      <div className="flex items-center justify-center px-4 h-16">
      </div>
    </header>
  );
};
